/** Backend refIds are UUIDs — the one shape a listing slug (`all`,
 *  `admin`, `jetfresh`, `baldor/baldor-df`, …) can never take. */
const UUID_SEGMENT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** `decodeURIComponent` that reads a malformed escape (a lone `%` in a
 *  hand-typed URL) as "not a segment" instead of throwing out of a render. */
function decodeSegment(raw: string): string | null {
  try {
    return decodeURIComponent(raw);
  } catch {
    return null;
  }
}

/**
 * The UUID that `<base>/<segment>` names, or `null` when the path is not
 * exactly one UUID segment under `base` — a listing slug, a nested path, a
 * malformed escape, or a different base entirely.
 *
 * Vue registers `<base>/:orderId` beside its listing routes; React cannot —
 * a dynamic segment outranks the `/*` splat the listings are served from,
 * so every slug would land on the detail page. Deciding by the segment's
 * SHAPE inside the splat keeps the listings authoritative.
 */
export function uuidSegmentUnder(base: string, pathname: string): string | null {
  const prefix = `${base}/`;
  if (!pathname.startsWith(prefix)) return null;
  const segment = decodeSegment(pathname.slice(prefix.length));
  return segment !== null && UUID_SEGMENT.test(segment) ? segment : null;
}
